import { render, staticRenderFns } from "./AlertaPreco.vue?vue&type=template&id=6a41e52a"
import script from "./AlertaPreco.vue?vue&type=script&lang=js"
export * from "./AlertaPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports